import { Search } from 'lucide-react';

const SearchBar = ({ value, onChange }) => {
  return (
    <div className="relative max-w-md mx-auto mb-8" data-testid="search-bar">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground w-5 h-5" />
      <input
        type="text"
        placeholder="Hledat položku..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-secondary/50 border border-white/20 focus:border-primary focus:ring-2 focus:ring-primary/20 h-12 pl-12 pr-4 rounded-full backdrop-blur-md text-white placeholder:text-muted-foreground outline-none transition-all"
        data-testid="search-input"
      />
    </div>
  );
};

export default SearchBar;